import styled from 'styled-components';

import { WithChildren } from '@exact-magic/react-utils';

const Base = styled.div`
  position: relative;
  flex: 1;
`;

const Wrapper = styled.div`
  position: absolute;
  padding: var(--size-spacing-04);
  border: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  gap: var(--size-spacing-05);
  overflow-y: auto;
  padding-top: 78px;
  padding-bottom: 96px;
  > div {
    width: 100%;
    max-width: 780px;
    margin: 0 auto;
  }
`;

export type MessagesContainerProps = WithChildren;

export const Container = ({ children }: MessagesContainerProps) => {
  return (
    <Base>
      <Wrapper>{children}</Wrapper>
    </Base>
  );
};
